export const addStyle = css => {
	global.document.head.appendChild(
		Object.assign(global.document.createElement("style"), { innerText: css }),
	);
};

export const prepareGoogleRecaptcha = googleRecaptcha =>
	new Promise(resolve => googleRecaptcha.ready(() => resolve(googleRecaptcha)));
